import { IModel, Model, ModelRecord } from './Model';

export interface IVisitSectionTypeModel extends IModel {
  visitSectionTypeId: number;
  name: string;
}

export class VisitSectionTypeModel
  extends Model
  implements ModelRecord<IVisitSectionTypeModel>
{
  visitSectionTypeId: number;
  name: string;

  constructor(params: Partial<IVisitSectionTypeModel>) {
    super(params);
    this.visitSectionTypeId = _.defaultTo(params.visitSectionTypeId, 0);
    this.name = _.defaultTo(params.name, '');
  }
}
